import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // 导入 Vuetify 的样式文件
import router from './router'
import '@mdi/font/css/materialdesignicons.css'; // 导入图标字体
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ToastPlugin from "@/plugins/ToastPlugin"; 

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.use(CKEditor)
Vue.use(ToastPlugin);
const opts = {icons: {
    iconfont: 'mdi', // 使用MDI图标
    values: {
      success: 'mdi-check-circle',
      error: 'mdi-alert-circle',
      warning: 'mdi-alert',
      info: 'mdi-information'
    }
  },} // 定义 Vuetify 的配置选项（如果需要）
const vuetify = new Vuetify(opts)

document.title = '即刻上岸';

new Vue({
  vuetify,
  router,
  render: h => h(App),
}).$mount('#app')
